import * as React from 'react';
import { Box, List, Typography } from '@mui/material';

import { AssignedBuilding, AssignedBuildingProps } from './assigned-building';

interface AssignedBuildingListProps {
  assignedBuildings: Array<AssignedBuildingProps>;
}

export const AssignedBuildingList: React.FC<AssignedBuildingListProps> = (props) => {
  const { assignedBuildings } = props;

  return assignedBuildings.length > 0 ? (
    <Box
      sx={{
        maxHeight: 400,
        overflowY: 'auto',
      }}
    >
      <List>
        {(assignedBuildings || []).map(({ buildingId, title, subtitle, userId }) => (
          <AssignedBuilding
            key={`assigned-building-${buildingId}`}
            userId={userId}
            buildingId={buildingId}
            title={title}
            subtitle={subtitle}
          />
        ))}
      </List>
    </Box>
  ) : (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 120,
      }}
    >
      <Typography color="textSecondary">No assigned buildings</Typography>
    </Box>
  );
};
